/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

console.log('[filters debug] script loaded', window.location.pathname);

  function initCustomFilterToggle() {
    if (window.matchMedia('(max-width: 767px)').matches) return;
    var btn = document.querySelector('.collection__filter_button_custom');
    var filtersEl = document.querySelector('collection-filters.collection__filters[data-collection-filters]');

    // Se non siamo in una pagina collection o manca qualcosa, esci
    if (!btn || !filtersEl) return;

    // Evita doppia inizializzazione
    if (btn.dataset.filtersToggleInit === '1') return;
    btn.dataset.filtersToggleInit = '1';

    // Stato iniziale: chiuso
    document.body.classList.remove('filters-open');
    btn.setAttribute('aria-expanded', 'false');

    function setBtnState(isOpen) {
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      btn.textContent = isOpen
        ? btn.dataset.labelOpen
        : btn.dataset.labelClosed;
    }

    btn.addEventListener('click', function () {
      var isOpen = document.body.classList.toggle('filters-open');
      setBtnState(isOpen);
    });

    // Chiudi con i bottoni nativi del tema
    document.addEventListener('click', function (e) {
      var closeBtn = e.target && e.target.closest && e.target.closest('[data-close-filters]');
      if (!closeBtn) return;

      if (document.body.classList.contains('filters-open')) {
        document.body.classList.remove('filters-open');
        setBtnState(false);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initCustomFilterToggle);
  document.addEventListener('shopify:section:load', initCustomFilterToggle);






  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
